// extracted by mini-css-extract-plugin
export default {"container":"LegalPages_container__Gt0NY","content":"LegalPages_content__NbZgi"};